<template>
  <v-card
    class="mx-auto"
  >
    <v-row align="center">
      <v-expansion-panels accordion>
        <v-expansion-panel
          v-for="(about, index) in aboutInfo"
          :key="index"
        >
          <v-expansion-panel-header>
            {{ about.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ about.content }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      aboutInfo: [
        {
          title: 'What is Crew Saver?',
          content: `Crew Saver is a free quiz app built to help football officials
            review questions about rules. Questions come from various sources
            throughout the officiating community.`      
        },
        {
          title: 'What is planned for Crew Saver?',
          content: `In the future, you will be able to save your record of 
           right and wrong answers, submit your own comments and questions, as 
            well as other features still being planned.`
        },
        {
          title: 'Can I send in quiz questions, recommendations, or corrections?',
          content: `Absolutely! You'll be able to do that in the app eventually 
            but, for now, just send me an email at hello@fridaynightstripes.com.`
        }
      ]
    }
  }
}
</script>